import { combineReducers } from "@reduxjs/toolkit";
import AuthSlice from "./auth/AuthSlice";
import CartSlice from "./cart/CartSlice";
import ReviewSlice from "./order/ReviewSlice";
import MyAccountSlice from "./myaccount/MyAccountSlice";
import { authApi } from "./auth/authApi";
import { homeApi } from "./home/homeApi";
import { commonApi } from "./common/commonApi";
import { myAccountApi } from "./myaccount/myAccountApi";
import { productApi } from "./product/productApi";
import { CartApi } from "./cart/CartApi";
import { orderApi } from "./order/orderApi";

const AllReducers = combineReducers({
  auth: AuthSlice.reducer,
  cart: CartSlice.reducer,
  review: ReviewSlice.reducer,
  myaccount: MyAccountSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [homeApi.reducerPath]: homeApi.reducer,
  [commonApi.reducerPath]: commonApi.reducer,
  [myAccountApi.reducerPath]: myAccountApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [CartApi.reducerPath]: CartApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
});

export type RootState = ReturnType<typeof AllReducers>;
export default AllReducers;
